import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QueryDetailModel } from 'src/app/core/models/QueryDetailModel';
import { User } from 'src/app/core/models/user';
import { UserService } from 'src/app/core/services/user.service';
import { ClarificationQueryListService } from '../clarification-query-list.service';
import { AdminService } from '../../admin/admin.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-view-previous-query-details',
  standalone: false,
  templateUrl: './view-previous-query-details.component.html',
  styleUrl: './view-previous-query-details.component.less'
})
export class ViewPreviousQueryDetailsComponent {
  queryCode: number = 0;
  currentUser: User = new User();
  queryReferenceNumber: string = '';
  queryDetails: QueryDetailModel[] = [];
  partnerUserMaster:{ item_id: any; item_text: any }[] = [];
  CCSubDepartmentsMaster:{ item_id: any; item_text: any }[] = [];

  showQueryIndex: number = 0;
  calledFromReopen : number = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private messageService: NzMessageService,
    private userService: UserService,
    private queryService: ClarificationQueryListService,
    private adminService: AdminService
  ) {
    this.queryCode = +(this.route.snapshot.paramMap.get('queryCode') ?? 0);
    this.calledFromReopen = +(this.route.snapshot.paramMap.get('calledFromReopen') ?? 0);
  }
  ngOnInit() {
    this.currentUser = this.userService.getCurrentUser();
    if (this.currentUser?.User_Code == null) {
      window.location.href = '/';
    }
    if (this.queryCode == 0) {
      this.messageService.error("Please select proper query reference number"); 
      this.router.navigate(['/home']);
    }
    else {
      this.queryService.canViewQuery(this.queryCode, this.currentUser.User_Code ?? 0).subscribe({
        next: (response: any) => {
          if (response.isAccessible) {
            this.queryService.getQueryDetails(this.queryCode).subscribe({
              next: (data: any) => {
                if (data.output.length > 0) {
                  this.queryDetails = data.output;
                  if(this.calledFromReopen == 0)
                  {
                    this.queryDetails = this.queryDetails.filter(queryDetls => !queryDetls.Active);
                  }
                  this.queryReferenceNumber = this.queryDetails[0].Query_Reference_Number;
                  this.adminService.getAllRegisteredPartners().subscribe({
                    next: (response: any) => {
                      if (response.output.length > 0) {
                        for (var i = 0; i < response.output.length; i++) {
                          this.partnerUserMaster.push({ item_id: response.output[i].User_Code, item_text: response.output[i].User_Name });
                        }
                      }
                    },
                    error: (error) => {
                      this.messageService.error("Error occurred while fetching the user details"); 
                      console.log(error);
                    }
                  });

                  this.adminService.getAllSubDeptMapping().subscribe({
                    next: (response: any) => {
                      if (response.output.length > 0) {
                        for (var i = 0; i < response.output.length; i++) {
                          this.CCSubDepartmentsMaster.push({ item_id: response.output[i].Sub_Dept_Code, item_text: response.output[i].Department_Name + ' - ' + response.output[i].Sub_Dept_Name});
                        }
                      }
                    },
                    error: (error) => {
                      this.messageService.error("Error occurred while fetching the Department details"); 
                      console.log(error);
                    }
                  });
                }
                else
                {
                  this.redirectToHome("Please select proper query reference number.");
                }
              },
              error: (error) => {
                this.redirectToHome("Error occurred while fetching the query details.");
              }
            });
          }
          else {
            this.redirectToHome("You are not authorized to view the selected Query Details.");
          }
        },
        error: (error) => {
          this.redirectToHome("Error occurred while fetching the query details.");
        }
      });
    }
  }
  
  redirectToHome(erroMsg : string)
  {    
    this.messageService.error(erroMsg);
    this.router.navigate(['/home']);
  }

  toggleQuery(queryIndex: any) {
    this.showQueryIndex = (this.showQueryIndex == queryIndex) ? -1 : queryIndex;
  }

  redirectBack()
  {
    this.router.navigate((this.calledFromReopen) ? ['/clarification-query/reopen-query/' + this.queryCode] : ['/clarification-query/view-query/' + this.queryCode])
  }
}
